import { render, staticRenderFns } from "./CallTableSmsTemplateActions.vue?vue&type=template&id=39c696c4"
import script from "./CallTableSmsTemplateActions.vue?vue&type=script&lang=js"
export * from "./CallTableSmsTemplateActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports